import { getRequest } from '@/core';
import { preferredVendors } from '@/requests';

export default async function getPreferredVendorsRequest() {
	let url = preferredVendors.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}